import { __ } from '@wordpress/i18n';

// export const TABS = [
//   { id: 'analytics', label: 'Analytics', icon: 'fas fa-chart-line' }, // This will be a dropdown
//   { id: 'general', label: 'General', icon: 'fas fa-cog' },
//   { id: 'typography', label: 'Typography', icon: 'fas fa-font' },
//   { id: 'integration', label: 'Integration', icon: 'fas fa-plug', badge: 'New' },
//   { id: 'design', label: 'Design Options', icon: 'fas fa-palette' },
//   { id: 'advanced', label: 'Advanced', icon: 'fas fa-sliders-h' },
//   { id: 'support', label: 'Support', icon: 'fas fa-life-ring' }
// ];

export const TABS = [
  { id: 'general', label: __('General', 'havenlytics'), icon: 'fas fa-cog' },
  // { id: 'page-setup', label: __('Page Setup & Permalink', 'havenlytics'), icon: 'fas fa-link' },
  { id: 'design', label: __('Design', 'havenlytics'), icon: 'fas fa-palette' },
  { id: 'search', label: __('Search', 'havenlytics'), icon: 'fas fa-search' },
  { id: 'properties', label: __('Properties', 'havenlytics'), icon: 'fas fa-building' },
  { id: 'property-details', label: __('Property Details', 'havenlytics'), icon: 'fas fa-info-circle' }, // dropdown later
  // { id: 'user-agent', label: __('User & Agent', 'havenlytics'), icon: 'fas fa-users' },
  // { id: 'email', label: __('Email', 'havenlytics'), icon: 'fas fa-envelope' },
  { id: 'shortcodes', label: __('Shortcodes', 'havenlytics'), icon: 'fas fa-code', badge: __('New', 'havenlytics') },
  // { id: 'import-export', label: __('Import & Export', 'havenlytics'), icon: 'fas fa-exchange-alt', badge: __('New', 'havenlytics') },
  // { id: 'integration', label: __('AI Integration', 'havenlytics'), icon: 'fas fa-robot', badge: __('Soon', 'havenlytics') },
  // { id: 'advanced', label: __('Advanced', 'havenlytics'), icon: 'fas fa-sliders-h' },
];

export const GOOGLE_FONTS = [
  'Plus Jakarta Sans',
  'Montserrat',
  'Roboto',
  'Open Sans',
  'Lato',
  'Poppins',
  'Raleway',
  'Merriweather',
  'Playfair Display',
  'Quicksand',
  'Nunito',
  'Ubuntu',
  'Rubik',
  'Inter',
  'Work Sans',
  'Karla',
  'Archivo',
  'Manrope',
  'Hind',
  'Source Sans Pro',
  'Exo 2',
  'Oswald',
  'Fira Sans'
];

export const FONT_WEIGHTS = [
  { value: '300', label: __('Light (300)', 'havenlytics') },
  { value: '400', label: __('Regular (400)', 'havenlytics') },
  { value: '500', label: __('Medium (500)', 'havenlytics') },
  { value: '600', label: __('Semi-Bold (600)', 'havenlytics') },
  { value: '700', label: __('Bold (700)', 'havenlytics') }
];